// 20261022: conversation cache limits, configurable PER DEVICE (localStorage, not user-scoped: a desktop PWA can keep
// more than a phone). Defaults = the values the caches were built with. Bigger = more old rooms/topics open instantly,
// but more storage and slower saves (every save rewrites a whole room/topic entry).
// No imports on purpose (used by dbUtils.ts and chatConverCache.ts).
export type CacheLimitName = "chatRooms" | "chatMsgs" | "wpTopics" | "wpMsgs";

export const CacheLimitDefs: Record<CacheLimitName, { key: string; def: number; options: number[] }> = {
  chatRooms: { key: "cnf_cache_chat_rooms", def: 100, options: [20, 50, 100, 200, 500] }, // customer + supplier combined (was 50 until 2026-10-22)
  chatMsgs: { key: "cnf_cache_chat_msgs", def: 100, options: [50, 100, 200, 500] },
  wpTopics: { key: "cnf_cache_wp_topics", def: 200, options: [100, 200, 500, 1000, 2000] }, // WP + Task combined
  wpMsgs: { key: "cnf_cache_wp_msgs", def: 100, options: [50, 100, 200, 500] }, // >= WP_CONVER_PAGE_SIZE (50)
};

export const CacheConfig = {
  get(name: CacheLimitName): number {
    const d = CacheLimitDefs[name];
    try {
      const v = Number(localStorage.getItem(d.key));
      return d.options.includes(v) ? v : d.def; // only allowed values
    } catch (e) {
      return d.def;
    }
  },

  set(name: CacheLimitName, value: number): void {
    const d = CacheLimitDefs[name];
    try {
      if (value === d.def) localStorage.removeItem(d.key);
      else localStorage.setItem(d.key, String(value));
    } catch (e) { }
  },
};
